<template lang="html">
  <section class="pageWrap articlePage">
    <section class="operationWrap">
      <div class="searchWrap" @keyup.enter.stop="carryScreen('enter')">
<!--        <el-select @change="carryScreen" v-model="screenData.type" placeholder="文章类型" clearable  class="inpW">-->
<!--          <el-option  v-for="item in $config.articleTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--        </el-select>-->
        <el-select @change="carryScreen" v-model="screenData.status" placeholder="文章状态" clearable  class="inpW">
          <el-option  v-for="item in $config.articleStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input v-model.trim="screenData.keyword" placeholder="标题" clearable></el-input>
        <el-button @click="carryScreen('click')" type="primary" icon="el-icon-search"></el-button>
      </div>
      <div class="btnWarp">
        <el-button @click="clickNewlyBuild" type="primary">新建文章</el-button>
      </div>
    </section>
    <section class="tableWrap">
      <el-table :data="tableDataList" border stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="100" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="100" align="center">
          <template v-slot="scope">
            <el-tooltip popper-class="tooltipBox"	 :content="scope.row.title" placement="top">
                <div class="ellipsisCell">{{scope.row.title}}</div>
            </el-tooltip>

          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="200" align="center">
          <template v-slot="scope">
            <el-tooltip popper-class="tooltipBox"	 :content="scope.row.description" placement="top">
              <div class="ellipsisCell">{{scope.row.description}}</div>
            </el-tooltip>
<!--            tooltipBox-->
<!--            el-tooltip__popper-->
<!--            <el-popover-->
<!--                placement="top" title="存储" width="200" trigger="hover" :content="scope.row.description">-->
<!--              <div class="ellipsisCell">{{scope.row.description}}</div>-->
<!--            </el-popover>-->

          </template>
        </el-table-column>

        <el-table-column prop="type" label="类型" width="100" align="center"></el-table-column>
        <el-table-column prop="cover" label="封面" width="90" align="center">
          <template v-slot="scope">
            <el-image v-if="scope.row.type!=='最新公告'"  class="tableCover"
                       :src="scope.row.cover+'!w300'"
                       :preview-src-list="[scope.row.cover]">
            </el-image>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template v-slot="scope">
            <span v-if="scope.row.status=='online'" style="color: var(--suc-color)">已发布</span>
            <span v-else-if="scope.row.status=='offline'" style="color:var(--war-color)">未发布</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdOn" label="创建时间" width="120" align="center">
          <template v-slot="scope">
            <span>
              {{scope.row.createdOn?$moment(scope.row.createdOn).format('YYYY-MM-DD'):'--'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width="130" align="center" fixed="right">
          <template v-slot="scope">
            <el-button @click="clickReleaseOffline(scope)" v-if="scope.row.status==='offline'" type="text" size="mini" style="color: var(--par1-color)">发布
            </el-button>
            <el-button @click="clickDel(scope)" v-if="scope.row.status==='offline'" type="text" size="mini" style="color: var(--dan-color)">删除</el-button>
            <el-button @click="clickModify(scope)" v-if="scope.row.status==='offline'" type="text" size="mini" style="color:var(--suc-color)">修改</el-button>
            <el-button @click="clickReleaseOffline(scope)" type="text" v-if="scope.row.status==='online'" size="mini" style="color: var(--war-color)">下线
            </el-button>
          </template>
        </el-table-column>


      </el-table>



    </section>
    <section class="paginationWrap">
      <el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="screenData.c_page"
                      :page-sizes="[6,10,15,30,50,100,150,200,300]"
                      :page-size="screenData.c_size" layout="total,sizes, prev, pager, next, jumper"
                      :total="screenData.c_total"></el-pagination>
    </section>


  </section>
</template>

<script>
import API from '@/api/api.js'
// articleDetails,articleList,articleDel
export default {
  name: "index.vue",
  data(){
    return{
      screenData:{
        keyword:null,
        type:null,
        status:null,
        c_total:0,
        c_size:10,
        c_page:1,
      },
      tableDataList:[]
    }
  },
  created() {
    this.obtainDataList()
  },
  mounted() {
  },
  methods:{
    carryScreen(val){
      console.log(val)
      this.screenData.c_page = 1;
      this.obtainDataList()
    },
    handleSizeChange(val) {
      console.log(val);
      this.screenData.c_size = val;
      this.screenData.c_page = 1;
      this.obtainDataList();
    },
    handleCurrentChange(val) {
      this.screenData.c_page = val;
      this.obtainDataList();
    },


    obtainDataList(){
      let params = {};
      params.keyword = this.screenData.keyword;
      params.type = this.screenData.type;
      params.pageNum = this.screenData.c_page;
      params.pageSize = this.screenData.c_size;
      params.status = this.screenData.status;//状态，online-在线，offline-不在线
      API.articleList(params).then(res=>{
        console.log(res.data,'文章列表')
        let data = res.data ? res.data : {}
        let list = data.list ? data.list : [];
        this.tableDataList = list;
        this.screenData.c_total = data.total

      }).catch(err=>{
        console.log(err,'cw')
      })
    },
    clickNewlyBuild(){
      this.$router.push(`/article/newlyBuild`)
      // let {href} = this.$router.resolve('/article/newlyBuild')
      // window.open(href,'_blank')
    },

    clickModify(scope){
      let {row,$index} = scope;
      this.$router.push(`/article/modify/${row.id}`)
    },
    clickDel(scope){
      let {row,$index} = scope;
      this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {};
        params.id = row.id;
        API.articleDel(params).then(res=>{
          this.$message.success('文章删除成功')
          let c_page = this.$config.handleListDelPage(this.screenData,1);
          this.screenData.c_page = c_page;
          this.obtainDataList();
        }).catch(err=>{
          console.log(err,'cw')
        })

      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    clickReleaseOffline(scope){
      let {row,$index} = scope;
      let params = {};
      params.id = row.id;
      let msgText;
      if(row.status === 'offline'){
        msgText = '文章发布成功'
        params.status = 'online'
      }else if(row.status === 'online') {
        msgText = '文章下线成功'
        params.status = 'offline'
      }
      API.articleModifyStatus(params).then(res => {
        this.$message.success(msgText)
        let c_page = this.$config.handleListDelPage(this.screenData, 1);
        this.screenData.c_page = c_page;
        this.obtainDataList();
      }).catch(err => {
        console.log(err, 'cw')
      })
    },



  }
}
</script>

<style type="text/css" scoped>
@import "../../config/css/operation.css";
@import "../../config/css/pagination.css";
@import "../../config/css/table.css";
.articlePage{

}
.tableWrap{

}
.tableCover{
  width:64px;
  height:36px;
  object-fit: cover;
}
.ellipsisCell{

}





</style>
